import _extends from 'babel-runtime/helpers/extends';

import BusinessDynamicFormItem from './Business.vue';
import MForm from 'm-form';
import _each from 'lodash/each';
import { format, subDays } from 'date-fns';

export default {
  name: 'DynamicForm',

  componentName: 'DynamicForm',

  components: {
    MForm: MForm
  },

  props: {
    formConfig: {
      type: Object,
      default: function _default() {}
    },

    // 表单值
    formValue: {
      type: Object,
      required: true
    },

    formItemList: {
      type: [Array, Object],
      required: true
    },

    layout: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    customFormItem: {
      default: function _default() {
        return BusinessDynamicFormItem;
      }
    }
  },

  data: function data() {
    return {
      datePickerDefaultParams: {
        align: 'left',
        type: 'daterange',
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd',
        rangeSeparator: this.$t('form.timeseparator'),
        startPlaceholder: this.$t('form.starttime'),
        endPlaceholder: this.$t('form.endtime'),
        pickerOptions: {
          shortcuts: [{
            text: this.$t('form.pastWeek'),
            onClick: function onClick(picker) {
              picker.$emit('pick', [format(subDays(new Date(), 7), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]);
            }
          }, {
            text: this.$t('form.pastMonth'),
            onClick: function onClick(picker) {
              picker.$emit('pick', [format(subDays(new Date(), 30), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]);
            }
          }, {
            text: this.$t('form.past3Month'),
            onClick: function onClick(picker) {
              picker.$emit('pick', [format(subDays(new Date(), 90), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]);
            }
          }]
        }
      }
    };
  },


  computed: {
    innerFormItemList: function innerFormItemList() {
      var _this = this;

      // 为 date-picker 添加默认配置，由于组件支持数组与对象的形式，所以需要为这两种类型都做支持，是数组的返回数组，对象的返回对象
      if (Array.isArray(this.formItemList)) {
        return this.formItemList.map(function (item) {
          if (item.type === 'date-picker') {
            item.params = _extends({}, _this.datePickerDefaultParams, item.params);
          }
          return item;
        });
      }

      var list = {};

      _each(this.formItemList, function (item, key) {
        if (item.type === 'date-picker') {
          item.params = _extends({}, _this.datePickerDefaultParams, item.params);
        }
        list[key] = item;
      });

      return list;
    }
  },

  methods: {
    resetFields: function resetFields() {
      return this.$refs.form.resetFields();
    },
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    clearValidate: function clearValidate(cb) {
      return this.$refs.form.clearValidate(cb);
    },
    validateField: function validateField(cb) {
      return this.$refs.form.validateField(cb);
    }
  }
};